
import React, { useState } from "react";
import { DownBtn, UpBtn, UserLogo } from "../../assets";
import NumPad from "../numpad/NumPad";
import { useClickOutside } from "../../hooks/useClickOutside";
import { useKioskContext } from "../../store/Context";
import "./loginpage.css";
import { getToken } from "../../Api/API";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";

const Login = () => {
  const {
    setCurrentScreen,
    language,
    setLanguage,
    text,
    isHenryCounty,
  } = useKioskContext();

  const [offenderId, setOffenderId] = useState("");
  const [showNumPad, setShowNumPad] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const clickOutside = useClickOutside(() => {
    setShowDropdown(false);
  });

  const handleClick = async () => {
    if (loading) return;

    if (!offenderId.trim()) {
      toast.error(
        language === "1"
          ? "Ingrese su número de participante."
          : "Please enter your participant number.",
        { toastId: "error" }
      );
      return;
    }

    setLoading(true);

    try {
      const { data, error: err } = await getToken(
        offenderId.trim()
      );

      if (err) {
        toast.error(err, {
          toastId: "error",
        });
        return;
      }

      if (!data?.offenderNumber) {
        toast.error(
          language === "1"
            ? "No se pudo validar al participante."
            : "Unable to validate participant.",
          { toastId: "error" }
        );
        return;
      }
      localStorage.setItem(
        "offenderId",
        data.offenderNumber
      );
      setCurrentScreen(1);
    } catch (error) {
      console.error("Kiosk login error:", error);

      toast.error(
        language === "1"
          ? "Algo salió mal."
          : "Something went wrong.",
        { toastId: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  const renderDropDown = () => (
    <div ref={clickOutside} className="dropDownList">
      <div
        style={{ top: "28%" }}
        className="imgContainer"
      >
        <img src={UpBtn} alt="" />
      </div>

      <div
        onClick={() => {
          setLanguage("0");
          localStorage.setItem("language", "0");
          setShowDropdown(false);
        }}
        className={
          language === "0"
            ? "activeDropDownItem"
            : "dropDownItem"
        }
      >
        English
      </div>

      <div
        onClick={() => {
          setLanguage("1");
          localStorage.setItem("language", "1");
          setShowDropdown(false);
        }}
        className={
          language === "1"
            ? "activeDropDownItem"
            : "dropDownItem"
        }
      >
        Spanish
      </div>
    </div>
  );

  return (
    <div>
      {loading && <Loader />}

      <div className="login">
        <div
          onClick={() => setShowDropdown(!showDropdown)}
          className="dropDownContainer"
        >
          <span className="dropDownText">
            {language === "1" ? "Spanish" : "English"}
          </span>

          <img
            className="imgContainer"
            src={DownBtn}
            alt=""
          />

          {showDropdown && renderDropDown()}
        </div>

        {isHenryCounty && (
          <div className="paymentMessage">
            {text.paymentMessage}
          </div>
        )}

        <div className="primaryText">
          {text.loginText}
        </div>

        <div className="inputContainer">
          <img
            className="userLogo"
            src={UserLogo}
            alt=""
          />

          <input
            onClick={() => setShowNumPad(!showNumPad)}
            placeholder={text.offenderNumber}
            disabled={true}
            value={offenderId}
            className="inputField"
          />
        </div>

        <NumPad
          value={offenderId}
          setValue={setOffenderId}
          nextBtnFunc={handleClick}
        />
      </div>
    </div>
  );
};

export default Login;
